import {call, put} from 'redux-saga/effects';
import {clientQuery} from 'Core/data/GraphQLApi';
import {endpoints} from 'Core/defaultValues';
import {ExceptionManager} from 'Core/logManager';
// Actions
import {reportsMainGenerateReportProgress} from 'Redux/actions';

import {getTimeZone} from 'Modules/reports/views/main/components/reportsTab/helper';

function* getDiagnosticIndicatorDetailsReport(report, event) {
    const {timeZone, name,reportTimeRanges} = report;
    const {startRange, endRange} = report.filters;
    const {
        filterType,
        filterArray,
        page,
        rowsPerPage,
        sortField,
        sortOrder,
        otherFilters
    } = event.filters;
    try {
        const newReport = JSON.parse(JSON.stringify(report))

        let data = yield call(
            clientQuery,
            `query getDiagnosticIndicatorDetailsReport ($conditions: ReportConditionsInput, $limit: Int, $offset: Int) {
              Report: getDiagnosticIndicatorDetailsReport (conditions: $conditions, limit: $limit, offset: $offset) {
                items {
                    date
                    dateTime
                    eventName
                    abs
                    absActiveLamp
                    airBagIndicator
                    brakeIndicator
                    brake
                    coolantLight
                    cruiseControl
                    ignitionStatus
                    milStatus
                    oilPressure
                    pto
                    seatBelt
                    dtc
                }
                total
                limit
                offset
                category
              }
            }`,
            {
                "conditions": {
                    reportName: 'DiagnosticIndicatorDetailsReport',
                    category: {
                        field: filterType,
                        value: filterArray?.id
                    },
                    timeZone: getTimeZone(timeZone),
                    dateRange: {
                        fields: [
                            "unitTime"
                        ],
                        GTE: startRange,
                        LTE: endRange,
                        reportTimeRanges
                    },
                    sortField: {
                        field: sortField || "deviceId",
                        order: sortOrder === 'desc' ? 'DESC' : 'ASC'
                    }
                },
                limit: rowsPerPage,
                offset: page
            },
            endpoints.GRAPHQL_PX_REPORTING
        );
        if (data && data.Report) {
            newReport.summary = data.Report
            newReport.loadingSummary = false
            yield put(reportsMainGenerateReportProgress(newReport))
        } else {
            newReport.loadingSummary = false
            yield put(reportsMainGenerateReportProgress(newReport))
        }
    } catch (exc) {
        report.loadingSummary = false
        ExceptionManager(exc, '/reports/DiagnosticIndicatorsReport', 'getDiagnosticIndicatorDetailsReport');
        yield put(reportsMainGenerateReportProgress(report))
    }
}

export default getDiagnosticIndicatorDetailsReport;
